import { throttle } from 'frame-throttle';
import React from 'react';
import { compose, lifecycle, withHandlers, withProps } from 'recompose';

const ScrollListenerEnhancer = lifecycle<HandleScroll, {}>({
  componentDidMount() {
    document.addEventListener('scroll', throttle(this.props.handleScroll));
  },
  componentWillUnmount() {
    document.removeEventListener('scroll', throttle(this.props.handleScroll));
  },
});

const ScrollBoxEnhancer = withProps({
  scrollBox: React.createRef(),
});

const ScrollHandlerEnhancer = withHandlers<ScrollBox & Props, HandleScroll>({
  handleScroll: props => _ => {
    const el = props.scrollBox.current;
    if (
      !props.isLoading &&
      el &&
      el.getBoundingClientRect().bottom <= 2 * window.innerHeight
    ) {
      props.loadMore();
    }
  },
});

type ScrollBox = {
  scrollBox: React.RefObject<HTMLDivElement>;
};

type HandleScroll = {
  handleScroll(event: UIEvent): void;
};

type Props = {
  isLoading: boolean;
  loadMore(): void;
};

export default compose<ScrollBox, Props>(
  ScrollBoxEnhancer,
  ScrollHandlerEnhancer,
  ScrollListenerEnhancer,
);
